import { render, staticRenderFns } from "./HotelReviewers.vue?vue&type=template&id=48d2df39&"
import script from "./HotelReviewers.vue?vue&type=script&lang=js&"
export * from "./HotelReviewers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d2df39')) {
      api.createRecord('48d2df39', component.options)
    } else {
      api.reload('48d2df39', component.options)
    }
    module.hot.accept("./HotelReviewers.vue?vue&type=template&id=48d2df39&", function () {
      api.rerender('48d2df39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/HotelReviewers.vue"
export default component.exports